import { useEffect } from "react";
import { focusManager, FocusField } from "../focus/FocusManager";

export function useFocusScope(scope: string, fields: FocusField[]) {
  useEffect(() => {
    focusManager.setScope(scope);
    focusManager.setFields(fields);
    return () => {
      focusManager.clear();
    };
  }, [scope, fields]);
}
